import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { BaseService } from '../base.service';
import { AngularFireDatabase } from 'angularfire2/database';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: []
})
export class DashboardComponent implements OnInit {
  private subscription: Subscription;
  title_component: string;

  constructor(
    private baseService: BaseService,
    private db: AngularFireDatabase
  ) {}

  ngOnInit() {
    this.baseService.pageNameChange$.subscribe(
      newPageName => {
              this.title_component = newPageName;
            }
      );
  }
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/dashboard.component.ts